import type {
  BackendBet,
  BackendStake,
  SSRBetEntity,
  SSRStakeEntity,
  TransformedBet,
  TransformedStake,
} from './types';

import { getDecimalByEntryPrice } from './utils/get-decimal-by-entry-price';
import { isBackendBetEntryFromClient } from './utils/is-backend-bet-entry-from-client';

export const transformStake = (entry: BackendStake | SSRStakeEntity): TransformedStake => ({
  id: entry.id,
  type: entry.type,
  isOpen: entry.isOpen,
  names: entry.names,
  params: 'parameters' in entry ? entry.parameters : (entry as SSRStakeEntity).params,
});

export const transformBet = (entry: BackendBet | SSRBetEntity): TransformedBet => ({
  id: entry.id,
  stakeId: entry.stakeId,
  type: entry.type,
  key: entry.key,
  price: isBackendBetEntryFromClient(entry) ? getDecimalByEntryPrice(entry) : entry.price,
  isOpen: entry.isOpen,
  names: entry.names,
});
